module.exports = __webpack_public_path__ + "img/hamburger.5d6bc92a.svg";